import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { AppRoutingModule } from './app-routing.module';
import { UiModule } from './ui.module';
import { HttpClientModule } from '@angular/common/http';
import { AppComponent } from './app.component';
import { SignBrowserComponent } from './sign-browser/sign-browser.component';
import { SIGNS_URL } from './sign.service';
import { SignCardComponent } from './sign-card/sign-card.component';
import { SignViewerComponent } from './sign-viewer/sign-viewer.component';
import { SignPageComponent } from './sign-page/sign-page.component';
import { HoverImageSwapDirective } from './hover-image-swap.directive';
import { SignSearchComponent } from './sign-search/sign-search.component';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';

@NgModule({
  declarations: [
    AppComponent,
    SignBrowserComponent,
    SignCardComponent,
    SignViewerComponent,
    SignPageComponent,
    HoverImageSwapDirective,
    SignSearchComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    BrowserAnimationsModule,
    ReactiveFormsModule,
    FormsModule,
    UiModule
  ],
  providers: [
    {
      provide: SIGNS_URL,
      useValue: '/db.json'
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}
